<template>
  <v-footer padless class="footer">
    <v-col class="text-center" cols="12">
      {{ new Date().getFullYear() }} — <strong>Quantum Computing School</strong>
    </v-col>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped>
.footer{
    background: radial-gradient(circle, rgba(174,238,216,1) 0%, rgba(168,233,148,1) 100%);
}
</style>